import { render } from "./FAQsGroup.vue?vue&type=template&id=e62da150"
import script from "./FAQsGroup.vue?vue&type=script&lang=js"
export * from "./FAQsGroup.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__